import { Box, Button, DialogContent, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { language, LanguageType } from "../../utils/LanguageUtils";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Title } from "@mui/icons-material";

interface PopupProps {
    open: boolean;
    onClose: () => void;
    message?: string;
    arrayOfMessage?: string[];
    title?: string;
    onValidation?: () => void;
    titleButtonValidation?: string;
    titleButtonCancel?: string;
    credentials?: string;
    children?: React.ReactNode;
}

export const ConfirmationModal = (props: PopupProps) => {
    const lang: LanguageType = language();
    const message = lang.modalConfirmation;

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            className="popup-background"
        >
            <Title className="popup-header">
                <WarningAmberIcon sx={{ fontSize: 60, color: "#f57c00" }} />
            </Title>
            <DialogContent>
                {props.message ? (
                    <p>{props.message}</p>
                ) : (
                    <Typography sx={{ whiteSpace: "pre-line", mt: 2 }}>
                        {message}
                    </Typography>
                )}
                {props.arrayOfMessage && (
                    <div>
                        {props.arrayOfMessage.map((e, i) => {
                            return <p key={i}>{e}</p>;
                        })}
                    </div>
                )}

                <Box
                    sx={{
                        mt: 3,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: 5,
                    }}
                    className="popup-actions-button"
                >
                    <ButtonCancel
                        onClick={(e) => {
                            e.stopPropagation();
                            props.onClose();
                        }}
                        size="large"
                        variant="contained"
                    >
                        <CloseIcon fontSize="medium" />
                    </ButtonCancel>
                    {props.onValidation && (
                        <ButtonConfirm
                            onClick={props.onValidation}
                            size="large"
                            variant="contained"
                            className="popup-validate-button"
                        >
                            <DeleteForeverIcon fontSize="medium" />
                        </ButtonConfirm>
                    )}
                </Box>
            </DialogContent>
        </Dialog>
    );
};

const ButtonConfirm = styled(Button)({
    width: "100px",
    backgroundColor: "#48bf53",
    color: "white",

    ":hover": {
        opacity: 0.9,
        backgroundColor: "#48bf53",
    },
});

const ButtonCancel = styled(Button)({
    width: "100px",
    backgroundColor: "#ac1e19",
    color: "white",

    ":hover": {
        opacity: 0.9,
        backgroundColor: "#ac1e19",
    },
});
